module.exports = __webpack_public_path__ + "img/60061.f481781a.png";